import request from '../utils/request'

// ==================== 商城统计 ====================

// 获取商城概览统计
export function getOverviewStats() {
  return request({
    url: '/store.statistics_controller/overview',
    method: 'get'
  })
}

// 获取销售趋势
export function getSalesTrend(params) {
  return request({
    url: '/store.statistics_controller/salesTrend',
    method: 'get',
    params
  })
}

// 获取分类分布
export function getCategoryDistribution() {
  return request({
    url: '/store.statistics_controller/categoryDistribution',
    method: 'get'
  })
}

// 获取最新订单
export function getLatestOrders(params) {
  return request({
    url: '/store.statistics_controller/latestOrders',
    method: 'get',
    params
  })
}

// 获取热销商品
export function getHotGoods(params) {
  return request({
    url: '/store.statistics_controller/hotGoods',
    method: 'get',
    params
  })
}

// ==================== 店主管理 ====================

// 获取店主列表
export function getOwnerList(params) {
  return request({
    url: '/store.owner_controller/list',
    method: 'get',
    params
  })
}

// 获取店主详情
export function getOwnerDetail(params) {
  return request({
    url: '/store.owner_controller/detail',
    method: 'get',
    params
  })
}

// 添加店主
export function addOwner(data) {
  return request({
    url: '/store.owner_controller/add',
    method: 'post',
    data
  })
}

// 编辑店主
export function editOwner(data) {
  return request({
    url: '/store.owner_controller/edit',
    method: 'post',
    data
  })
}

// 删除店主
export function deleteOwner(data) {
  return request({
    url: '/store.owner_controller/delete',
    method: 'post',
    data
  })
}

// 修改店主状态
export function changeOwnerStatus(data) {
  return request({
    url: '/store.owner_controller/changeStatus',
    method: 'post',
    data
  })
}

// 修改店主密码
export function changeOwnerPassword(data) {
  return request({
    url: '/store.owner_controller/changePassword',
    method: 'post',
    data
  })
}

// ==================== 店铺管理 ====================

// 获取店铺列表
export function getShopList(params) {
  return request({
    url: '/store.shop_controller/list',
    method: 'get',
    params
  })
}

// 获取店铺详情
export function getShopDetail(id) {
  return request({
    url: '/store.shop_controller/detail',
    method: 'get',
    params: { id }
  })
}

// 创建店铺
export function createShop(data) {
  return request({
    url: '/store.shop_controller/create',
    method: 'post',
    data
  })
}

// 更新店铺
export function updateShop(data) {
  return request({
    url: '/store.shop_controller/update',
    method: 'post',
    data
  })
}

// 删除店铺
export function deleteShop(id) {
  return request({
    url: '/store.shop_controller/delete',
    method: 'post',
    data: { id }
  })
}

// ==================== 分类管理 ====================

// 获取分类列表
export function getCategoryList(params) {
  return request({
    url: '/store.category_controller/list',
    method: 'get',
    params
  })
}

// 获取分类详情
export function getCategoryDetail(id) {
  return request({
    url: '/store.category_controller/detail',
    method: 'get',
    params: { id }
  })
}

// 创建分类
export function createCategory(data) {
  return request({
    url: '/store.category_controller/create',
    method: 'post',
    data
  })
}

// 更新分类
export function updateCategory(data) {
  return request({
    url: '/store.category_controller/update',
    method: 'post',
    data
  })
}

// 删除分类
export function deleteCategory(id) {
  return request({
    url: '/store.category_controller/delete',
    method: 'post',
    data: { id }
  })
}

// ==================== 商品管理 ====================

// 获取商品列表
export function getGoodsList(params) {
  return request({
    url: '/store.goods_controller/list',
    method: 'get',
    params
  })
}

// 获取商品详情
export function getGoodsDetail(id) {
  return request({
    url: '/store.goods_controller/detail',
    method: 'get',
    params: { id }
  })
}

// 创建商品
export function createGoods(data) {
  return request({
    url: '/store.goods_controller/create',
    method: 'post',
    data
  })
}

// 更新商品
export function updateGoods(data) {
  return request({
    url: '/store.goods_controller/update',
    method: 'post',
    data
  })
}

// 删除商品
export function deleteGoods(id) {
  return request({
    url: '/store.goods_controller/delete',
    method: 'post',
    data: { id }
  })
}

// ==================== 订单管理 ====================

// 获取订单列表
export function getOrderList(params) {
  return request({
    url: '/store.order_controller/list',
    method: 'get',
    params
  })
}

// 获取订单详情
export function getOrderDetail(id) {
  return request({
    url: '/store.order_controller/detail',
    method: 'get',
    params: { id }
  })
}

// 订单发货
export function shipOrder(data) {
  return request({
    url: '/store.order_controller/ship',
    method: 'post',
    data
  })
}

// 批量发货
export function batchShipOrder(data) {
  return request({
    url: '/store.order_controller/batchShip',
    method: 'post',
    data
  })
}

// 取消订单
export function cancelOrder(data) {
  return request({
    url: '/store.order_controller/cancel',
    method: 'post',
    data
  })
}

// 删除订单
export function deleteOrder(id) {
  return request({
    url: '/store.order_controller/delete',
    method: 'post',
    data: { id }
  })
}

// 导出订单（下载请用 utils/request.js 的 downloadFile，它会带上 Authorization 头）
export function exportOrders(params) {
  return request({
    url: '/store.order_controller/export',
    method: 'get',
    params
  })
}

// 订单统计
export function getOrderStatistics(params) {
  return request({
    url: '/store.order_controller/statistics',
    method: 'get',
    params
  })
}

// 同意退款
export function approveRefund(data) {
  return request({
    url: '/store.order_controller/approveRefund',
    method: 'post',
    data
  })
}

// 拒绝退款
export function rejectRefund(data) {
  return request({
    url: '/store.order_controller/rejectRefund',
    method: 'post',
    data
  })
}

// ==================== 订单商品管理 ====================

// 获取订单商品列表
export function getOrderGoodsList(params) {
  return request({
    url: '/store.order_goods_controller/list',
    method: 'get',
    params
  })
}

// 获取订单商品详情
export function getOrderGoodsDetail(id) {
  return request({
    url: '/store.order_goods_controller/detail',
    method: 'get',
    params: { id }
  })
}

// ==================== 省市区管理 ====================

// 获取省份列表
export function getProvinceList(params) {
  return request({
    url: '/region_controller/getProvinceList',
    method: 'get',
    params
  })
}

// 获取城市列表
export function getCityList(params) {
  return request({
    url: '/region_controller/getCityList',
    method: 'get',
    params
  })
}

// 获取区县列表
export function getAreaList(params) {
  return request({
    url: '/region_controller/getAreaList',
    method: 'get',
    params
  })
}
